import { FGSelectInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGCountrySelect, FGSRSHDateMaskInput } from "../../../../components";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";

export interface IDrupalKennelExportRequestFormProps {
  kennelExportRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalKennelExportRequestForm: React.FunctionComponent<IDrupalKennelExportRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const [kennels, kloading] = useReferential((a) => a.getOpenedKennels(0), true, []);
  return (
    <DrupalFormGenerator
      initialValues={initialdata}
      editMode={false}
      onSubmit={() => {}}
      loading={loading}
      saving={false}
      deleting={false}
      hideButtons
    >
      <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}>
        <div>
          <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} />
          {initialdata?.request?.status === ERequestState.EXECUTED && (
            <FieldGroup columns={2}>
              <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
            </FieldGroup>
          )}
        </div>
      </FieldGroup>
      <DrupalFieldSet title={t(ETLCodes.KennelExportRequest)}>
        <FieldGroup columns={2}>
          <div>
            <FGSelectInput name="kennelId" label={t(ETLCodes.Kennel)} items={kennels} loading={kloading} />
            <FGCountrySelect name="countryId" label={t(ETLCodes.Country)} includeBelgium={false} />
          </div>
        </FieldGroup>
      </DrupalFieldSet>
      <DrupalStepperButtonBloc backOnly />
    </DrupalFormGenerator>
  );
};
